function enviarPreInscricao(dados) {
    const opcoesEscola = ["Ensino Primário", "Iº Ciclo", "Infantário"];
    const opcoesBercario = ["Berçário", "1 ano", "2 anos", "3 anos", "4 anos", "5 anos"];
    const opcoesPrimario = ["1ª Classe", "2ª Classe", "3ª Classe", "4ª Classe", "5ª Classe", "6ª Classe"];
    const opcoesSecundario = ["7ª Classe"];
    const opcoesSexo = ["Masculino", "Feminino"];
    const opcoesSimNao = ["Sim", "Não"];

    const {
        escola,
        idade,
        classe,
        nomeAluno,
        dia,
        mes,
        ano,
        sexo,
        especial,
        irmaos,
        irmaosDescricao,
        edu1,
        numEdu1,
        emailEdu1,
        nacEdu1,
        edu2,
        numEdu2,
        emailEdu2,
        nacEdu2
    } = dados;

    // =========================
    // 🔎 VALIDAÇÕES MELHORADAS
    // =========================

    if (!opcoesEscola.includes(escola)) {
        return alert("Opção de escola inválida");
    }

    if (!nomeAluno || nomeAluno.trim().length < 3) {
        return alert("Nome do aluno inválido");
    }

    if (!dia || !mes || !ano) {
        return alert("Data de nascimento inválida");
    }

    if (!opcoesSexo.includes(sexo)) {
        return alert("Sexo inválido");
    }

    if (!opcoesSimNao.includes(especial)) {
        return alert("Resposta inválida para necessidades especiais");
    }

    if (!opcoesSimNao.includes(irmaos)) {
        return alert("Resposta inválida para irmãos");
    }

    // =========================
    // 🎯 VALIDAÇÃO INTELIGENTE ESCOLA / CLASSE
    // =========================

    if (escola === "Infantário") {
        if (classe && classe !== "-") {
            return alert("Infantário não deve ter classe");
        }
    }

    if (escola === "Ensino Primário") {
        if (!opcoesPrimario.includes(classe)) {
            return alert("Classe inválida para ensino primário");
        }
    }

    if (escola === "Iº Ciclo") {
        if (!opcoesSecundario.includes(classe)) {
            return alert("Classe inválida para Iº Ciclo");
        }
    }

    if (escola === "Infantário") {
        if (idade && !opcoesBercario.includes(idade)) {
            return alert("Idade/sala inválida para infantário");
        }
    }

    // =========================
    // 📦 FORM DATA
    // =========================

    const formData = new FormData();

    const safe = (v) => (v && v.trim ? v.trim() : v) || "";

    // Escola / percurso
    formData.append("entry.658352550", safe(escola));
    formData.append("entry.1916259863", safe(idade));
    formData.append("entry.1520005270", safe(classe));

    // Aluno
    formData.append("entry.423095836", safe(nomeAluno));
    formData.append("entry.59429657_day", safe(dia));
    formData.append("entry.59429657_month", safe(mes));
    formData.append("entry.59429657_year", safe(ano));
    formData.append("entry.478606091", safe(sexo));
    formData.append("entry.1207344835", safe(especial));
    formData.append("entry.1272926471", safe(irmaos));

    // descrição irmãos (evita null quebrar envio)
    formData.append("entry.935044953", safe(irmaosDescricao));

    // Educador 1
    formData.append("entry.1519627953", safe(edu1));
    formData.append("entry.329721116", safe(numEdu1));
    formData.append("entry.1390609283", safe(emailEdu1));
    formData.append("entry.175186655", safe(nacEdu1));

    // Educador 2
    formData.append("entry.2110731606", safe(edu2));
    formData.append("entry.2047861115", safe(numEdu2));
    formData.append("entry.1738872178", safe(emailEdu2));
    formData.append("entry.2084313853", safe(nacEdu2));

    // =========================
    // 🚀 ENVIO
    // =========================

    fetch("https://docs.google.com/forms/d/e/1FAIpQLSeJLLwux50B6S5wr_HinQ9Kf5QQE9oIgvWXzdOdG-goKI5TVQ/formResponse", {
        method: "POST",
        mode: "no-cors",
        body: formData
    })
    .then(() => {
        // ⚠ não significa sucesso real (limitação do Google Forms)
        alert("Pré-inscrição enviada com sucesso!");
    })
    .catch(() => {
        alert("Erro ao enviar pré-inscrição");
    });
}

export { enviarPreInscricao };